import React from "react";

import { Bubble } from "../../components/Bubble/Bubble";
import "./TypingIndicator.scss";

export interface TypingIndicatorProps {
  isTyping: boolean;
  isLeft: boolean;
}

export class TypingIndicator extends React.Component<TypingIndicatorProps> {
  constructor(props: TypingIndicatorProps) {
    super(props);
  }
  render() {
    const bubbleClass = this.props.isTyping ? "scc-typingBubble" : "scc-fadeOut scc-typingBubble";

    const className = this.props.isTyping ? "scc-typingIndicator" : "scc-typingIndicator scc-fadeOut";

    return (
      <Bubble className={bubbleClass} loadLate={false} isLeft={this.props.isLeft}>
        <div className={className}>
          <span />
          <span />
          <span />
        </div>
      </Bubble>
    );
  }
}
